import { useState, useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';

interface IdleConfig {
  timeout: number;
  onTimeout: () => void;
  throttle?: number;
}

export const useIdleTimeout = ({ timeout, onTimeout, throttle = 500 }: IdleConfig) => {
  const [state, setState] = useState<'Active' | 'Idle'>('Active');
  const [remaining, setRemaining] = useState<number>(0);

  const onIdle = () => {
    setState('Idle');
    onTimeout();
  };

  const onActive = () => {
    setState('Active');
  };

  const { getRemainingTime } = useIdleTimer({
    timeout,
    onIdle,
    onActive,
    throttle,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => clearInterval(interval);
  }, [getRemainingTime]);

  return {
    isIdle: state === 'Idle',
    remainingTime: remaining,
    reset: () => setState('Active'),
  };
};